import { render, staticRenderFns } from "./EdlFileUpload.vue?vue&type=template&id=f0995608&scoped=true&"
import script from "./EdlFileUpload.vue?vue&type=script&lang=js&"
export * from "./EdlFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./EdlFileUpload.vue?vue&type=style&index=0&id=f0995608&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0995608",
  null
  
)

export default component.exports